import { render, staticRenderFns } from "./UserTextFilter.vue?vue&type=template&id=323c4e04&scoped=true&"
import script from "./UserTextFilter.vue?vue&type=script&lang=js&"
export * from "./UserTextFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c4e04",
  null
  
)

export default component.exports